import { actionTypes } from './actions';

export const initialState = {};

const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DEVICE_V2_RESPONSE: {
      const { fingerprint, status } = action;
      return { ...state, fingerprint, status };
    }
    default:
      return state;
  }
};

export default requestReducer;
